// extracted by mini-css-extract-plugin
export default {"select":"cancel-order-modal_select__TNaGQ"};